interface CheckboxProps {
  active: boolean;
  id: string;
  label: string;
  groupId: string;
  toggle: (groupId: string, id: string, activate: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const className = `item${props.active ? " active" : ""}`;

  const toggle = () => {
    // If its active we want deactivate
    props.toggle(props.groupId, props.id, !props.active);
  };

  return (
    <li className={className} onClick={toggle}>
      {props.label}
    </li>
  );
};
